<template>
  <div class="api-test">
    <h3>API连接测试</h3>
    
    <div class="test-buttons">
      <button @click="testActivitiesApi" class="btn btn-primary">测试体测活动API</button>
      <button @click="testTestItemsApi" class="btn btn-primary">测试测试项目API</button>
      <button @click="testGradesApi" class="btn btn-primary">测试成绩查询API</button>
    </div>
    
    <div v-if="response" class="result">
      <pre>{{ response }}</pre>
    </div>
  </div>
</template>

<script>
import service from '@/utils/request'
import { ElMessage } from 'element-plus'

export default {
  name: 'ApiTest',
  data() {
    return {
      response: null
    }
  },
  methods: {
    // 测试体测活动API
    async testActivitiesApi() {
      try {
        this.response = '请求中...'
        console.log('测试体测活动API开始')
        const res = await service.get('/fitness/activities')
        this.response = JSON.stringify(res, null, 2)
        console.log('测试体测活动API成功:', res)
        ElMessage.success('体测活动API测试成功')
      } catch (error) {
        this.response = '请求失败: ' + (error.message || JSON.stringify(error))
        console.error('测试体测活动API失败:', error)
        ElMessage.error('体测活动API测试失败')
      }
    },
    
    // 测试测试项目API
    async testTestItemsApi() {
      try {
        this.response = '请求中...'
        console.log('测试测试项目API开始')
        const res = await service.get('/fitness/test-items')
        this.response = JSON.stringify(res, null, 2)
        console.log('测试测试项目API成功:', res)
        ElMessage.success('测试项目API测试成功')
      } catch (error) {
        this.response = '请求失败: ' + (error.message || JSON.stringify(error))
        console.error('测试测试项目API失败:', error)
        ElMessage.error('测试项目API测试失败')
      }
    },
    
    // 测试成绩查询API
    async testGradesApi() {
      try {
        this.response = '请求中...'
        console.log('测试成绩查询API开始')
        const res = await service.get('/teacher/grades/search', {
          params: {
            queryType: 'name',
            queryValue: '王浩'
          }
        })
        this.response = JSON.stringify(res, null, 2)
        console.log('测试成绩查询API成功:', res)
        ElMessage.success('成绩查询API测试成功')
      } catch (error) {
        this.response = '请求失败: ' + (error.message || JSON.stringify(error))
        console.error('测试成绩查询API失败:', error)
        ElMessage.error('成绩查询API测试失败')
      }
    }
  }
}
</script>

<style scoped>
.api-test {
  padding: 20px;
}

.test-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.result {
  margin-top: 20px;
  padding: 10px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 400px;
  overflow-y: auto;
}
</style>